// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FS8D","toggleWrap":"styles_toggleWrap__1kAtz","content":"styles_content__ZqQVf","selectAreaCode":"styles_selectAreaCode__1qcB_"};